<template>
  <div>
    <el-breadcrumb separator="/" class="top-div">
      <el-breadcrumb-item :to="{ path: '/share/department' }">部门管理</el-breadcrumb-item>
      <el-breadcrumb-item>部门详情</el-breadcrumb-item>
      <el-breadcrumb-item>{{ department_namea }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <el-button type="primary" class="btn-add" @click="comedit('row','new')" style="margin-bottom:28px">新增固定成本
    </el-button>


    <el-table
      :data="tableData"
      border
      :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}"
    >
<!--      <el-table-column-->
<!--        label="ID"-->
<!--        prop="id"-->
<!--        align="center"-->
<!--        width='259'-->
<!--      >-->
<!--      </el-table-column>-->
      <el-table-column label="时间" prop="year" align="center">
                <template slot-scope="scope">
                  {{scope.row.year}}-{{scope.row.month}}
                </template>
      </el-table-column>
      <el-table-column label="在岗人数" prop="person_count" align="center">
      </el-table-column>
      <el-table-column label="固定成本(万元)" prop="cost" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="300">
        <template slot-scope="scope">
          <span class="caozuo"  @click="comedit(scope.$index, scope.row)" style="color:#347ae2;cursor: pointer;">修改</span>
          <span class="caozuo"  @click="delColomn(scope.row.id)" style="color:#ec4b4b;cursor: pointer;">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-if="total > 0"
      :currentPage="currentPage"
      :total="total"
      :limit="limit"
      @handleCurrentChange="handleCurrentChange">
    </Pagination>


    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      class="diago"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="auto" :rules="rules">
        <el-form-item label="时间：" prop="year">
          <el-date-picker
            v-model="form.year"
            type="month"
            style="width:300px"
            value-format="yyyy-MM"
            placeholder="选择月">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="固定成本:" prop="cost">
          <el-input type="number" style="width:300px" v-model="form.cost" placeholder="请输入每月固定成本(万元)"></el-input>
          <span style="margin-left: 10px">万元</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" class="btn-cancel">取 消</el-button>
            <el-button type="primary" @click="uodata" class="btn-submit1">确 定</el-button>
        </span>
    </el-dialog>


  </div>
</template>

<script>
import {create_depart_cost, mod_depart_cost, get_depart_cost, del_depart_cost} from "../../api/user";
import Pagination from "../../components/Pagination";

export default {
  // 注册组件
  components: {
    Pagination
  },
  data() {
    return {
      department_namea: '',

      //  弹窗参数
      title: '',
      dialogVisible: false,
      form: {
        departments_id: '',
        year: '',
        month: '',
        cost: '',  //当月成本
        depart_cost_id:''
      },
      rules: {
        year: [
          {required: true, message: '请选择月份', trigger: 'change'}
        ],
        cost: [
          {required: true, message: '请输入固定成本', trigger: 'change'}
        ],
      },
      //  分页
      currentPage: 1,
      limit: 10,
      tableData: [],
      total:0,

    }
  },
  methods: {
    //删除
    delColomn(id){
      this.$confirm('确定删除该月记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            depart_cost_id:id
          }
          del_depart_cost(params).then(res => {
            if(res.code == 200){
              this.$message.success('删除成功')
              this.getData()
            }else{
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    //  提交新增
    uodata() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.title == '修改') {
            let params = {
              departments_id: this.form.departments_id,
              year: this.form.year.split('-')[0],
              month: this.form.year.split('-')[1],
              cost: this.form.cost,
              depart_cost_id:this.form.depart_cost_id
            }
            mod_depart_cost(params).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.$message.success('修改成功')
                this.getData()
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            let params = {
              departments_id: this.form.departments_id,
              year: this.form.year.split('-')[0],
              month: this.form.year.split('-')[1],
              cost: this.form.cost,
            }
            create_depart_cost(params).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.$message.success('添加成功')
                this.getData()
              } else {
                this.$message.error(res.msg)
              }
            })
          }


        } else {
          return false;
        }
      });
      //
      //
      // }
    },

    //  新增或者修改
    comedit(index, row) {
      if (row != 'new') {
        this.title = '修改'
        this.form.year = row.year+'-'+row.month
        this.form.month = ''
        this.form.cost = row.cost
        this.form.depart_cost_id = row.id
        this.dialogVisible = true
      } else {
        this.title = '新增'
        // this.form.departments_id = ''
        // this.form.name = ''
        this.form.year = ''
        this.form.month = ''
        this.form.cost = ''
        this.form.depart_cost_id = ''
        this.dialogVisible = true
      }
    },

    //  获取部门成本
    getData() {
      let params = {
        departments_id: this.form.departments_id,
        page: this.currentPage,
        limit: 10
      }
      get_depart_cost(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          // this.limit = res.limit;
          this.total = res.total
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
  mounted() {
    this.department_namea = this.$route.query.name
    this.form.departments_id = this.$route.query.id
    this.getData()
  }
}
</script>

<style scoped>
.diago >>> .el-dialog{
  min-width: 480px;
}
</style>



// WEBPACK FOOTER //
// src/views/share/bumen_xq.vue